const panels = {}

export default panels
